/**
 * Enums for MRSS Management
 */

export const QueueStatus = {
  PENDING: "PENDING",
  RUNNING: "RUNNING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
};

export const ApprovalStatus = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const FeedType = {
  SOCIAL: "SOCIAL",
  PARTNER: "PARTNER",
};

export const VideoSource = {
  ORIGINAL: "ORIGINAL",
  LOCAL: "LOCAL",
  EDITED: "EDITED",
  DUPLICATE: "DUPLICATE",
};

// Independent of VideoSource — a push's thumbnail choice, regardless of
// which video source is picked (mirrors PlatformSourceCard.js's Thumbnail
// selector, which is its own control, not nested under the source radio).
export const ThumbnailSource = {
  ORIGINAL: "ORIGINAL",
  CUSTOM: "CUSTOM",
};

export const StatusColors = {
  [QueueStatus.PENDING]: "#FFA500",
  [QueueStatus.RUNNING]: "#2196F3",
  [QueueStatus.COMPLETED]: "#4CAF50",
  [QueueStatus.FAILED]: "#F44336",
};

export const StatusLabels = {
  [QueueStatus.PENDING]: "Pending",
  [QueueStatus.RUNNING]: "Running",
  [QueueStatus.COMPLETED]: "Completed",
  [QueueStatus.FAILED]: "Failed",
};

export const SocialPlatform = {
  YOUTUBE: "YOUTUBE",
  TIKTOK: "TIKTOK",
  FACEBOOK: "FACEBOOK",
  INSTAGRAM: "INSTAGRAM",
  PINTEREST: "PINTEREST",
  SNAPCHAT: "SNAPCHAT",
  THREADS: "THREADS",
  DAILYMOTION: "DAILYMOTION",
  MSN: "MSN",
  OTHERS: "OTHERS",
};
